import { Directive, HostBinding } from '@angular/core';
import classNames from 'classnames';

@Directive({
  selector: '[iaSharedRadio]',
  standalone: true,
})
export class RadioDirective {
  @HostBinding('class')
  public get classAttribute(): string {
    return classNames([
      `tw-grid tw-h-6 tw-w-6 hb-group:tw-h-4 hb-group:tw-w-4 tw-cursor-pointer disabled:checked:after:!tw-bg-geyser tw-appearance-none tw-place-items-center tw-rounded-full tw-border tw-border-gray-300 hb-group:tw-border-[#8b939c] disabled:hb-group:tw-border-geyser
      tw-text-silver checked:tw-border-radio-button-primary hb-group:checked:tw-border-[#8b939c] checked:after:tw-visible checked:after:tw-block checked:after:mb-group:tw-h-3 checked:after:mb-group:tw-w-3
      checked:after:hb-group:tw-h-2.5 checked:after:hb-group:tw-w-2.5 checked:after:tw-rounded-full checked:after:tw-border checked:after:tw-border-white
      checked:after:mb-group:tw-bg-radio-button-primary checked:after:hb-group:tw-bg-midnight-green tw-shrink-0 disabled:tw-border-geyser
      disabled:tw-cursor-auto`,
    ]);
  }
}
